
/* Copyright 2011-2012 The MathWorks, Inc. */

define([
    "dojo/_base/declare",
    "dijit/_WidgetBase",
    "./_TooltipMixin",
    "dijit/_TemplatedMixin",
    "dojo/text!./templates/Tooltip.html"

], function (declare, _WidgetBase, _TooltipMixin, _TemplatedMixin, template) {

    return declare([_WidgetBase, _TemplatedMixin, _TooltipMixin], {
        /** @lends Label# */
        templateString: template

        /**
         * This is the widget for the Tooltip used for error/ warning states.
         */

    });

});

